<template>
  <div v-loading="loading">
    <div class="one_level" v-if="appList.length">
      <h3>视频列表</h3>
      <ul>
        <li
          v-for="(item, index) in appList"
          :key="index"
          :class="KsbClassID == item.KsbClassID ? 'one_active' : ''"
        >
          <div
            @click="switchData(item, index, 1)"
            :class="KsbClassID == item.KsbClassID ? 'one_active' : ''"
          >
            <img
              src="@/assets/Exam/chapter1.png"
              alt=""
              v-if="KsbClassID == item.KsbClassID"
            />
            <img src="@/assets/Exam/chapter.png" alt="" v-else />
            <p>
              {{ item.KsbClassName }}
            </p>
          </div>
        </li>
      </ul>
    </div>
    <!-- 第二层 -->
    <ul class="two_level" v-if="appList.length">
      <li
        v-for="(item, index) in twoList"
        :key="index"
        @click="switchData(item, index, 2)"
      >
        {{ item.KsbClassName }}
      </li>
    </ul>
    <!-- 第三层 -->
    <div class="three_level">
      <div class="dialog_cascader">
        <!-- 只有三层情况 -->
        <ul class="cascade_one" v-if="threeList.length">
          <li
            v-for="(item, index) in threeList"
            :key="index"
            :class="appID == item.id ? 'three_active' : ''"
            @click="getFourData(item)"
          >
            <div></div>
            <p>{{ item.KsbClassName }}</p>
          </li>
        </ul>
        <ul class="cascade_two" v-if="catalogueData.length">
          <li
            v-for="(item, index) in catalogueData"
            :key="index"
            :class="bookID == item.bookID ? 'three_active' : ''"
            @click="getSection(item, 0)"
          >
            <p>{{ item.bookName }}</p>
          </li>
        </ul>
        <ul class="cascade_two" v-if="sectionData.length">
          <li
            v-for="(item, index) in sectionData"
            :key="index"
            :class="chapterID == item.chapterID ? 'three_active' : ''"
            @click="getSection(item, 1, index)"
          >
            <p>{{ item.chapterName }}</p>
          </li>
        </ul>
        <!-- 最后一层表格 -->
        <div class="table_view">
          <el-table
            v-if="tableData.length"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            height="450"
            :row-key="getRowKeyOfTarget"
            @select="handleSelect"
            @select-all="handleSelectAll"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="summary" label="视频名称" width="230">
            </el-table-column>
          </el-table>
          <div class="table_p" v-if="loading == false">
            <p>已选择{{ multipleSelection.length }}个</p>
            <p>视频列表顺序与选取顺序保持一致</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ksPcApi from "@/api/examPc";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      loading: true,
      appList: [],
      KsbClassID: "", // 第一层选中的ID
      oneIndex: 0,
      active: 0,
      twoID: "", // 记录第二层选中的ID
      appID: "",
      AppEName: "",
      catalogueData: [], // 章
      oneObj: {},
      twoObj: {}, // 第二层当前点击信息
      threeObj: {},
      cascaderArr: "",
      twoList: [],
      tableData: [], // 最内层表格数据
      threeList: [],
      sectionData: [], // 视频小节的数据
      props: {
        value: "id",
        label: "KsbClassName",
        children: "children",
      },
      multipleSelection: [], // 表单选中
      bookID: "", // 用于记录
      chapterID: "",
      lastSelectedRows: [], // 用于记录全部取消的行
      isMounted: false
    };
  },
  props: {
    videoArr: Array,
  },
  mounted(){
    this.isMounted = true
    this.$nextTick(() => {
      this.setSelections()
    })
  },
  watch: {
    videoArr: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (this.videoArr.length > 0) {
          this.multipleSelection = this.videoArr;
        }
          this.setSelections()
        })
      }
    }
  },
  methods: {
    setSelections() {
      if (!this.$refs.multipleTable) return
      // 关键点2：先清空再设置
      this.$refs.multipleTable.clearSelection()
      this.tableData.forEach(row => {
        const shouldSelect = this.multipleSelection.includes(row)
        this.$refs.multipleTable.toggleRowSelection(row, shouldSelect.id)
      })
    },
    async getSubjectList() {
      const obj = {
        hid: JSON.parse(loginvuex.state.hid),
      };
      this.loading = true;
      const { data } = await ksPcApi.subjectList(obj);
      if (data.Status == 200) {
        this.appList = data.Data;
        this.operateData(this.appList);
        this.oneIndex = 0;
        this.twoList = this.appList[0].children; // 默认初始化
        if (!this.twoList.children && this.twoList[0].IsBook == 1) {
          // 只有三层直接取视频
        }
        // this.title = this.appList[0]?.KsbClassName; // 初始化默认第一个
        this.KsbClassID = this.appList[0].KsbClassID;
        this.appID = this.appList[0]?.applist[0].AppID;
        this.AppEName = this.appList[0]?.applist[0]?.AppEName;
        setTimeout(() => {
          this.loading = false;
        }, 500);
        // 默认初始化调取
          this.getVideoSort("init");
        if (this.appList[0]?.children) {
          this.twoID = data.Data[0]?.children[0].id;
        }
       
      } else {
        this.$message.error(data.Msg || data.Data);
      }
    },
    // 操作数据
    operateData(data) {
      data.forEach((item) => {
        item.id = item.AppID ? item.AppID : item.KsbClassID;
        if (item.applist || item.Childs) {
          item.id = item.AppID ? item.AppID : item.KsbClassID;
          item.children = item.applist ? item.applist : item.Childs;
          item.children.forEach((zitem) => {
            zitem.KsbClassName = zitem.KsbClassName
              ? zitem.KsbClassName
              : zitem.CName;
          });
          this.operateData(item.children);
        }
      });
    },
    getRowKeyOfTarget(row) {
      return row.id;
    },
    handleSelect(selection, row) {
      if (row) {
        if (selection.includes(row)) {
          // console.log("选中行：", row);
          // 选中行
          this.multipleSelection.push(row);
        } else {
          // 取消选中行
          this.multipleSelection = this.multipleSelection.filter((item) => {
            return item.id !== row.id;
          });
          // console.log("取消选中行：", row);
        }
      }
      console.log(this.multipleSelection);
    },
    handleSelectAll(selection) {
      if (selection.length === 0) {
        // 取消全选
        if (this.lastSelectedRows) {
          const filteredArr1 = this.multipleSelection.filter((item1) => {
            return !this.lastSelectedRows.some(
              (item2) => JSON.stringify(item1) === JSON.stringify(item2)
            );
          });
          const filteredArr2 = this.lastSelectedRows.filter((item2) => {
            return !this.multipleSelection.some(
              (item1) => JSON.stringify(item1) === JSON.stringify(item2)
            );
          });
          this.multipleSelection = [...filteredArr1, ...filteredArr2];
        }
      } else {
        // 全选 过滤掉单选的时候push
        this.multipleSelection = this.multipleSelection.concat(selection);
        this.multipleSelection = this.multipleSelection.reduce(
          (acc, current) => {
            const isDuplicate = acc.some(
              (item) => JSON.stringify(item) === JSON.stringify(current)
            );
            return isDuplicate ? acc : [...acc, current];
          },
          []
        );
        // console.log(selection, "全选");
      }
    },
    handleSelectionChange(val) {
      this.lastSelectedRows = val;
      return;
      if (val.length && this.multipleSelection.length) {
        console.log(val);
        console.log(this.multipleSelection);
        this.multipleSelection.forEach((item) => {
          val.forEach((zitem) => {
            if (item.VideoID !== zitem.VideoID) {
              //过滤掉
              const obj = {
                VideoName: item.summary,
                VideoID: item.VideoID,
                Type: item.type,
                BookID: item.bookID,
                AppID: item.AppID,
              };
              this.multipleSelection.push(obj);
            }
          });
        });
      } else {
        val.forEach((item) => {
          //过滤掉
          const obj = {
            VideoName: item.summary,
            VideoID: item.VideoID,
            Type: item.type,
            BookID: item.bookID,
            AppID: item.AppID,
          };
          this.multipleSelection.push(obj);
        });
      }
      //   this.multipleSelection = [];
      console.log(this.multipleSelection, "<<=====multipleSelectionIds");
    },
    // 整合第三层数据
    integrationDataList(item, type) {
      if (item.children) {
        this.$nextTick(() => {
          this.threeList = item.children.map((item) => {
            item.id = item.AppID;
            return item;
          });
          if (type === "init") {
            this.getFourData(this.threeList[0], "init");
          }
        });
      } else {
        // 第一个接口没有第三层的情况下
        if (item.IsBook == 1) {
          //  没章直接取节
          this.getSection(item, 0);
        } else {
          // 有章
          this.appID = item.AppID;
          this.getVideoSort(type);
        }
      }
    },
    // 获取第四和五层数据
    getFourData(zitem, type) {
      this.appID = zitem.AppID;
      let row = {};
      this.twoObj.children.forEach((item) => {
        if (item.AppID == zitem.AppID) {
          row = item;
        }
      });
      if (row) {
        // 有第三层根据具体情况点击去获取章节
        if (row[0]?.IsBook == 1) {
          // 没章直接取节
          this.getSection(zitem, 0);
        } else {
          // 有章
          this.appID = row.AppID || row.appID;
          this.getVideoSort(type);
        }
      }
    },
    // 获取小节
    async getSection(val, type, index) {
      if (type == 0) {
        this.bookID = val.bookID;
        const obj = {
          appEName: this.AppEName,
          bookID: val.IsBook == 1 ? val.AppID : val.bookID,
        };
        this.loading = true;
        const { data } = await ksPcApi.videoChapter(obj);
        if (data.Status == 200) {
          setTimeout(() => {
            this.loading = false;
          }, 500);
          this.sectionData = data.Data.map((item) => {
            item.AppID = val.IsBook == 1 ? val.AppID : val.bookID;
            return item;
          });
          this.chapterID = this.sectionData[0].chapterID;
          this.tableData = this.sectionData[0].names;
          // this.bookID =
          //   data.Data[0]?.names[0]?.IsBook == 1 ? data.Data[0]?.names[0]?.AppID : data.Data[0]?.names[0]?.bookID;
        } else {
          this.$message.error(data.Msg || data.Data);
          this.loading = false;
        }
      } else {
        this.chapterID = val.chapterID;
        this.tableData = this.sectionData[index].names;
      }
      // 回显遗留选中的数据
      // toggleSelection
      this.$nextTick(() => {
        this.$refs.multipleTable.clearSelection(); // 先清空
        console.log(this.multipleSelection, "遗留问题",this.tableData);
        if (this.multipleSelection.length) {
          const selectedIds = this.multipleSelection.map(item=>{
            return item.id
          })
          console.log(selectedIds,'selectedIds');
          this.tableData.forEach(item=>{
            const shouldSelect = selectedIds.includes(item.id)
            console.log(shouldSelect,'shouldSelect');
            this.$refs.multipleTable.toggleRowSelection(item, shouldSelect)
          })
          return
          this.tableData.forEach((item) => {
            this.multipleSelection.forEach((zitem) => {
              if (item.id === zitem.id) {
                this.$refs.multipleTable.toggleRowSelection(zitem,true);
                // this.$refs.multipleTable.toggleRowSelection(zitem,true);
              }
            });
          });
        }
      });
    },
    // 层级切换
    switchData(item, index, type) {
      if (this.twoID == item.id || this.KsbClassID == item.KsbClassID) {
        return;
      }
      if (type == 1) {
        // 第一层级
        this.KsbClassID = item.KsbClassID;
        this.twoList = this.appList[index].children;
        this.oneIndex = index;
        // 默认初始
        if (item.children[0]?.children) {
          this.appID = item.children[0].id;
          this.twoID = item.children[0].id;
          // this.twoID = item.children[0].children[0].id
          // this.appID = item.children[0].children[0].id
          // 有第三层默认第一条 调取章接口
          this.twoObj = item.children[0];
          // this.getFourData(item.children[0]?.children[0], "init");
          this.integrationDataList(item.children[0], "init");
        } else {
          // 调取章接口
          this.appID = item.children[0].id;
          this.twoID = item.children[0].id;
          this.twoObj = item.children[0];
          this.integrationDataList(this.twoObj, "init");
          // this.getFourData(item.children[0], "init");
        }
      } else if (type == 2) {
        this.twoID = item.id;
        // this.appID = item.AppID;
        this.twoObj = item;
        this.integrationDataList(item);
      }
      // 重置
      this.threeList = [];
      this.catalogueData = [];
      this.sectionData = [];
      this.tableData = [];
    },
    // 获取视频章节
    async getVideoSort(type) {
      const obj = {
        appID: this.appID,
      };
      const { data } = await ksPcApi.getVideoCatalogue(obj);
      if (data.Status == 200) {
       
        this.catalogueData = data.Data.map((item) => {
          item.state = false;
          item.expand = false;
          item.appID = obj.appID;
          item.bookName = item.bookName.split("_")[0];
          item.ID = item.bookID; // 统一ID字段名
          return item;
        });
        if (type === "init") {
          this.getSection(this.catalogueData[0], 0);
          setTimeout(() => {
            this.getSection(this.sectionData[0], 1, 0);
          }, 1000);
        }
        let zindex = 0;
        this.threeList = this.threeList.map((item, index) => {
          if (item.AppID == this.appID) {
            // 匹配到往对应的appID里面塞章节
            zindex = index;
            // item.children = this.catalogueData;
          }
          return item;
        });
        this.bookID = data.Data[0].bookID;
        // this.threeList[zindex].children = this.catalogueData;
        // this.oneObj = this.catalogueData[0];
      } else {
        this.$message.error(data.Msg || data.Data);
      }
    },
    init() {
      this.getSubjectList();
    },
  },
  created() {
    this.init();
  },

};
</script>
<style lang="scss" scoped>
.one_level {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e3e6eb;
  padding-bottom: 24px;
  h3 {
    font-size: 26px;
    margin-right: 24px;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
    > li {
      min-width: 160px;
      height: 40px;
      border-radius: 4px;
      //   border: 1px solid #000;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 24px;
      position: relative;
      &:hover {
        background: #ecf2fe;
        color: #0052d9;
        > div {
          background: #ecf2fe;
          color: #0052d9;
        }
      }
      > div {
        // border: 1px solid #000;
        // &:hover {
        //   background: #ecf2fe;
        //   color: #0052d9;
        // }
        border-radius: 4px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        position: absolute;
        top: 32%;
        left: 6%;
        > img {
          width: 24px;
          height: 24px;
          margin-right: 12px;
        }
      }
    }
  }
}
.one_active {
  background: #ecf2fe !important;
  color: #0052d9 !important;
}
.two_level {
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  border-bottom: 1px solid #e3e6eb;
  padding: 24px;
  li {
    min-width: 70px;
    height: 40px;
    text-align: center;
    margin-right: 24px;
    &:hover {
      border-bottom: 4px solid #0052d9;
    }
  }
}
.two_bd {
  border-bottom: 4px solid #0052d9;
}
.dialog_cascader {
  display: flex;
}
.cascade_one {
  list-style-type: none;
  height: 60vh;
  overflow-y: scroll;
  border-left: 1px solid #e1e3e1;
  li {
    width: 260px;
    min-height: 40px;
    display: flex;
    align-items: center;
    color: #7f7f7f;
    padding: 12px;
    border-bottom: 1px solid #e1e3e1;
    border-right: 1px solid #e1e3e1;
    > div {
      width: 24px;
      height: 24px;
      background-image: url("../../../assets/Exam/book.png");
      background-size: 24px;
      background-repeat: no-repeat;
    }
    &:hover {
      color: #0052d9;
      background: #ecf2fe;
      > div {
        background-image: url("../../../assets/Exam/book1.png");
      }
    }
    p {
      margin-left: 16px;
    }
    // >img{
    //     width: 24px;
    //     height: 24px;
    //     margin-right: 16px;
    // }
  }
}
.three_active {
  color: #0052d9 !important;
  background: #ecf2fe !important;
  > div {
    background-image: url("../../../assets/Exam/book1.png") !important;
  }
}
.cascade_two {
  list-style-type: none;
  height: 60vh;
  overflow-y: scroll;
  border-left: 1px solid #e1e3e1;
  li {
    width: 260px;
    min-height: 40px;
    display: flex;
    align-items: center;
    color: #7f7f7f;
    padding: 12px;
    border-bottom: 1px solid #e1e3e1;
    border-right: 1px solid #e1e3e1;
    &:hover {
      color: #0052d9;
      background: #ecf2fe;
    }
  }
}
::v-deep .cell {
  text-align: center;
}
.table_view {
  > .table_p {
    padding: 24px;
    display: flex;
    p {
      &:nth-child(1) {
        color: red;
        margin-right: 24px;
      }
      &:nth-child(2) {
        color: #7f7f7f;
      }
    }
  }
}
</style>